import { Autocomplete, Box, TextField, useMediaQuery } from '@mui/material';
import debounce from 'lodash.debounce';

import { useState, useEffect, useRef } from 'react';
import { allProductName } from '../../../../../../../../api/menu';
import { isDisabled } from '@testing-library/user-event/dist/utils';

const ProductSelect = ({
  handleValue,
  firstValueId,
  firstValue,
  isReset,
  setIsReset,
  isDisableProduct,
}) => {
  const matchTablet = useMediaQuery('(min-width:832px)');
  const [inputValue, setInputValue] = useState('');
  const [inputDebounce, setInputDebounce] = useState('');
  const [open, setOpen] = useState(false);

  const inputDebounceChange = useRef(
    debounce((value) => {
      setInputDebounce(value);
    }, 1000)
  ).current;

  const [datas, setDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [product, setProduct] = useState(null);
  const [productFix, setProductFix] = useState(null);

  useEffect(() => {
    const getProductName = async () => {
      setIsLoading(true);
      let datas = {
        page: 1,
        pageSize: 100,
        search: inputDebounce,
      };

      try {
        const {
          data: { data: dataNames },
        } = await allProductName(datas);
        setDatas(dataNames.products);
      } catch (err) {
        console.error(err);
        setDatas([]);
      } finally {
        setIsLoading(true);
      }
    };

    getProductName();
  }, [inputDebounce]);

  useEffect(() => {
    if (isReset) {
      return setProduct({
        idProduk: firstValueId,
        namaProduk: firstValue,
      });
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    if (firstValueId !== 0) {
      return setProduct({
        idProduk: firstValueId,
        namaProduk: firstValue,
      });
    }
  }, []);

  useEffect(() => {
    if (product !== productFix) {
      return handleValue(product.namaProduk, product.idProduk);
      return setProductFix(product);
    }
  }, [product, productFix]);

  return matchTablet ? (
    <Autocomplete
      disabled={isDisableProduct}
      sx={{ minWidth: '100%', bgcolor: '#FAFAFA', color: 'red' }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        inputDebounceChange(newInputValue);
      }}
      options={datas}
      getOptionLabel={(option) => option.namaProduk}
      value={product}
      onChange={(e, newValue) => setProduct(newValue)}
      loading={isLoading}
      renderInput={(params) => <TextField {...params} placeholder="Product*" />}
    />
  ) : (
    <Autocomplete
      disabled={isDisableProduct}
      sx={{ minWidth: '100%', bgcolor: '#FAFAFA', color: 'red' }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        inputDebounceChange(newInputValue);
      }}
      options={datas}
      getOptionLabel={(option) => option.namaProduk}
      renderInput={(params) => <TextField {...params} placeholder="Product*" />}
      // renderOption={(props, option) => (
      //   <Box
      //     component="li"
      //     sx={{
      //       fontSize: '12px',
      //       background: 'rgba(200, 200, 204, .1)',
      //       padding: '4px',
      //       mb: 0.5,
      //       borderRadius: '8px',
      //     }}
      //     onClick={() => setProduct(option)}
      //   >
      //     {option.namaProduk}
      //   </Box>
      // )}
      value={product}
      onChange={(e, newValue) => setProduct(newValue)}
      loading={isLoading}
    />
  );
};

export default ProductSelect;
